import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3b2ab526")

_pushScopeId("data-v-3b2ab526")
const _hoisted_1 = { class: "request-list" }
const _hoisted_2 = { class: "filter-wrapped" }
const _hoisted_3 = { class: "status-desc" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "ellipse -royalBlue" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "ellipse -pelorous" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "ellipse -brinkPink" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DateNameFilter = _resolveComponent("DateNameFilter")
  const _component_RequestCard = _resolveComponent("RequestCard")
  const _component_CancelConfirm = _resolveComponent("CancelConfirm")
  const _component_Alert = _resolveComponent("Alert")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("section", _hoisted_3, [
          _createVNode("ul", null, [
            (_ctx.statusDesc[0] && _ctx.statusDesc[0].length > 0)
              ? (_openBlock(), _createBlock("li", _hoisted_4, [
                  _hoisted_5,
                  _createVNode("span", null, _toDisplayString(_ctx.statusDesc[0]), 1)
                ]))
              : _createCommentVNode("", true),
            _createVNode("li", null, [
              _hoisted_6,
              _createVNode("span", null, _toDisplayString(_ctx.statusDesc[1]), 1)
            ]),
            _createVNode("li", null, [
              _hoisted_7,
              _createVNode("span", null, _toDisplayString(_ctx.statusDesc[2]), 1)
            ])
          ])
        ]),
        _createVNode(_component_DateNameFilter, {
          class: "request-list__filter",
          filterState: _ctx.filterState,
          onOnSearch: _ctx.onSearch
        }, null, 8, ["filterState", "onOnSearch"])
      ]),
      _createVNode(_Transition, { name: "list" }, {
        default: _withId(() => [
          (_ctx.isShow)
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                class: ["request-list__items", _ctx.state.list.length === 0 ? '-empty' : '']
              }, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filtedList, (item, index) => {
                  return (_openBlock(), _createBlock(_component_RequestCard, {
                    key: index,
                    item: item,
                    kind: _ctx.state.kind,
                    type: item.type ?? _ctx.RequestListType.Request,
                    onCancelRequest: _ctx.CancelRequest
                  }, null, 8, ["item", "kind", "type", "onCancelRequest"]))
                }), 128))
              ], 2))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    (_ctx.isRequest)
      ? (_openBlock(), _createBlock(_component_CancelConfirm, {
          key: 0,
          ref: "cancel$",
          accept: _ctx.CancelAccept
        }, null, 8, ["accept"]))
      : _createCommentVNode("", true),
    (!!_ctx.alert.content)
      ? (_openBlock(), _createBlock(_component_Alert, {
          key: 1,
          alert: _ctx.alert,
          "onUpdate:clear": _cache[1] || (_cache[1] = 
      () => {
        _ctx.alert.content = '';
      }
    )
        }, null, 8, ["alert"]))
      : _createCommentVNode("", true)
  ], 64))
})